
export const baseURL: string = "https://nargona.com:8090";
// export const baseURL: string = "http://192.168.55.197:8081";
export const localUrl: string = "http://192.168.55.197";
// export const homePageUrl: string = "http://nargon";
//https://nargona.com:8088/listing/allClients/i

